import { useTranslation } from 'react-i18next';

interface ExtractionButtonProps {
  className?: string;
  onClick: () => void
}

const ExtractionButton = ( {
  className = '',
  onClick
} : ExtractionButtonProps ) => {
  const { t } = useTranslation();

  return (
    <div className={ className + ' w-full h-full p-1' }>
      <div className='py-1 relative flex justify-center'>
        <div
          id={'warning_button'}
          className={'flex items-center gap-2 justify-between w-fit px-5 py-2 rounded-xl bg-blue-300 hover:bg-blue-200 transition-colors duration-150 font-medium text-slate-700'}
          onClick={ onClick }
        >
          <label htmlFor={'warning_button'} className='w-fit px-2 text-center whitespace-nowrap'>
            { t( 'translation:extract_data' ) }
          </label>
        </div>
      </div>
    </div>
  );
};

export default ExtractionButton;